module.exports = __webpack_public_path__ + "img/yuangong01.a5d3dd59.jpg";